var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.itensSelecionados && _vm.rateios)?_c('b-row',[_c('b-col',[_c('app-box',{attrs:{"titulo":"Total a ser rateado"}},[_vm._v(_vm._s(_vm._f("currency")(_vm.valorASerRateado)))])],1),_c('b-col',[_c('app-box',{attrs:{"titulo":"Total disponível para ratear","corBox":_vm.corBox,"corTexto":_vm.corTexto}},[_vm._v(_vm._s(_vm._f("currency")(_vm.valorDisponivel)))])],1),_c('b-col',[_c('app-box',{attrs:{"titulo":"Total rateado","corBox":_vm.corBox,"corTexto":_vm.corTexto}},[_vm._v(_vm._s(_vm._f("currency")(_vm.valorRateado))+" |\n            "+_vm._s(_vm._f("currency")(_vm.percentualRateado,{
                        symbol: '%',
                        thousandsSeparator: '.',
                        fractionCount: 2,
                        fractionSeparator: ',',
                        symbolPosition: 'back',
                        symbolSpacing: false
                    })))])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }